import { Component, Injector } from "@angular/core";
import { AppComponentBase } from "@shared/common/app-component-base";

@Component({
    templateUrl: './failed-subscription.component.html',
    styleUrls:['./failed-subscription.component.scss']
  })
  export class FailedSubscription extends AppComponentBase {
    constructor(
      injector: Injector,
    ) {
      super(injector);
    }
  }